export const shadows = {
  xs: '0px 1px 3px rgba(0, 0, 0, 0.05)', // 5% opacity
  small: '0px 2px 6px rgba(0, 0, 0, 0.08)', // 8%
  medium: '0px 4px 12px rgba(0, 0, 0, 0.11)', // 11%
  large: '0px 6px 18px rgba(0, 0, 0, 0.12)', // 12%
  xlarge: '0px 8px 24px rgba(0, 0, 0, 0.14)', // 14%
};

export default shadows;
